import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const LegalLayout = ({ title, lastUpdate, children }) => (
  <div className="bg-amber-50 min-h-screen">
    <section className="bg-sky-100 border-b-4 border-slate-900 bg-dots py-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-1 font-bold text-slate-700 hover:text-pink-600 mb-4">
          <ChevronLeft className="w-4 h-4" /> Home
        </Link>
        <h1 className="font-display font-bold text-4xl lg:text-5xl text-slate-900">{title}</h1>
        {lastUpdate && (
          <p className="text-slate-600 mt-2 text-sm">Ultimo aggiornamento: {lastUpdate}</p>
        )}
      </div>
    </section>
    <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <article className="cartoon-card bg-white p-6 lg:p-10 space-y-6 text-slate-800 leading-relaxed">
        {children}
      </article>
    </section>
  </div>
);

export default LegalLayout;
